var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-navigator shadow"},[_c('div',{staticClass:"flex-parent"},[_c('div',{staticClass:"input-flex-container"},[_vm._l((_vm.visibleSections),function(section,index){return [(_vm.sections[index])?_c('router-link',{key:index,attrs:{"to":{
              path: `${section.id}`,
              params: { initialSchema: _vm.schemas[index] }
            }}},[_vm._v(" "+_vm._s(section.title)+" ")]):_vm._e()]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }